<template>
  <v-badge
    :model-value="accessList.length >= 2"
    color="grey-lighten-2"
    :content="accessList.length"
  >
    <v-btn
      variant="outlined"
      min-width="48"
      width="48"
      class="access-list-icon"
      :active="currentTab === 'access-list'"
      @click="setCurrentTab('access-list')"
    >
      <v-icon icon="mdi-account-group" />
    </v-btn>
  </v-badge>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';

const { jobProfile } = storeToRefs(useCurrentJobProfile());
const { currentTab } = storeToRefs(useDocumentRightPanel());
const { setCurrentTab } = useDocumentRightPanel();

const accessList = computed(() => jobProfile.value?.access_list ?? []);
</script>

<style lang="less" scoped>
.access-list-icon {
  border-color: @stroke-default;

  :deep(.v-icon) {
    color: @icon-default;
  }
}
</style>
